import GameCommonPostMessageActions from "./game_common_post_message_actions";

export default class DemoGamePostMessageActions extends GameCommonPostMessageActions{
    static CLASS="DemoGamePostMessageActions";

    lobby() {
        this._serviceFactory.openLinkService().goToLobby();
    }
}